/**
 * Shot detail page (server-rendered app/views/shot/show.jade).
 * Handles the like toggle and the owner's delete flow; everything else
 * on the page is server-rendered.
 */
angular.module("UI8.controllers").controller("ShotController", [
  "$scope",
  "$http",
  "$window",
  function ($scope, $http, $window) {
    $scope.init = function (data) {
      $scope.shotId = data._id;
      $scope.slug = data.slug;
      $scope.likes = data.likes || 0;
      $scope.liked = !!data.liked;
      $scope.canEdit = !!data.can_edit;
      $scope.loggedIn = !!$window.UI8.loggedIn;
      $scope.confirmDelete = false;
    };

    $scope.toggleLike = function () {
      if (!$scope.loggedIn) return;

      if ($scope.liked) {
        $scope.liked = false;
        $scope.likes = Math.max($scope.likes - 1, 0);
        $http.delete(
          "/account/favorite/" + $scope.shotId + "?json=1&type=shot"
        );
      } else {
        $scope.liked = true;
        $scope.likes += 1;
        $http.put("/account/favorite/" + $scope.shotId + "?json=1&type=shot");
      }
    };

    $scope.askDelete = function () {
      $scope.confirmDelete = true;
    };

    $scope.deleteShot = function () {
      $http.delete("/api/shots/" + $scope.shotId).then(
        function () {
          $window.location = "/shots";
        },
        function () {
          $scope.confirmDelete = false;
        }
      );
    };
  },
]);
